import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { UIKitBaseComponent } from '@macs-frontend/features';

export enum AvailableSizes {
  sm,
  xs,
  'square-sm',
}

export enum AvailableShapes {
  floating,
  square,
  'rounded-circle',
}

export enum AvailableColors {
  primary,
  secondary,
  green,
  red,
  blue,
  'primary-outline',
}

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'ui-kit-button',
  templateUrl: './button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonComponent extends UIKitBaseComponent {
  // @ts-expect-error
  @Input() iconLeft: string;
  // @ts-expect-error
  @Input() iconRight: string;
  // @ts-expect-error
  @Input() disabled: boolean;
  @Input() theme: any;
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() click: EventEmitter<any> = new EventEmitter();

  handleClick(e: any) {}

  get classes(): string {
    // eslint-disable-next-line functional/no-let
    let classes = '';
    classes += this.theme.color ? `button_${this.theme.color} ` : '';
    classes += this.theme.size ? `button_${this.theme.size} ` : '';
    classes += this.theme.shape ? `button_${this.theme.shape} ` : '';
    return classes;
  }
}
